module.exports = __webpack_public_path__ + "static/sai-kung-map-ea505fe817557a26d2db83f6728f4e7a.png";